import React from 'react';
import { Avatar } from '@material-ui/core';
import  '../styles/sidebar.css';
import { useSelector } from 'react-redux';
import { fetchUser } from '../features/UserSlice';
function Sidebar(props) {

    //fetched user from the redux store
    const loggedInUser = useSelector(fetchUser);

    const recentItem =(topic) =>(
        <div className="sidebar_recent_item">
            <span className="sidebar_hashtag">#</span>
            <span>{topic}</span>
        </div>
    );

    return (
        <div className="sidebar">
            <div className="sidebar_top">
                <img src="https://images.unsplash.com/photo-1485356824219-4bc17c2a2ea7?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=749&q=80" alt=""/>
                {loggedInUser.photoUrl?
                <Avatar src={loggedInUser.photoUrl} className="sidebar_avatar"/>:
                <Avatar className="sidebar_avatar">{loggedInUser.displayName[0]}</Avatar>
                }
                <h2>{loggedInUser.displayName}</h2>
                <h5>{loggedInUser.email}</h5>
            </div>

            <div className="sidebar_stats">
                <div className="sidebar_stat">
                    <h6>Who viewed you</h6>
                    <h6 className="sidebar_statNumber">2,578</h6>
                </div>
                <div className="sidebar_stat">
                    <h6>Views on post</h6>
                    <h6 className="sidebar_statNumber">3,191</h6>
                </div>
            </div>

            <div className="sidebar_bottom">
                <span>Recent</span>
                {recentItem('android')}
                {recentItem('trendingjobs')}
                {recentItem('softwareengineering')}
                {recentItem('design')}
            </div>
        </div>
    );
}

export default Sidebar;